"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToHue = void 0;
var hex_to_hsl_1 = require("./basic-conversion/hex-to-hsl");
var hexToHue = function (hex) { return (0, hex_to_hsl_1.hexToHsl)(hex)[0]; };
exports.hexToHue = hexToHue;
